import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Constants } from '../../constants/constants';
import { ApiService } from '../../service/api.service';
import { AuthenticationService } from '../../service/authentication.service';
import { ToastService } from '../../service/toast.service';
import { UtilService } from '../../service/util.service';

@Component({
  selector: 'app-certificate-summary',
  templateUrl: './certificate-summary.component.html',
  styleUrls: ['./certificate-summary.component.scss']
})
export class CertificateSummaryComponent implements OnInit {
  @Input() certificate: any;
  certificateDetail: any;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toastService: ToastService) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.getCertificateDetail();
  }

  getCertificateDetail() {
    this.utilService.showSpinner();
    this.apiService.getCertificateDetail(this.certificate.parentAccountId, this.certificate.id).then((data) => {
      this.utilService.hideSpinner();
      this.certificateDetail = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getCertificateDetail();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

}
